// extracted by mini-css-extract-plugin
export default {"second":"reviews_second__y9Sbr","card":"reviews_card__pNczV","cardBody":"reviews_cardBody__-BrL0"};